module.exports = __webpack_public_path__ + "img/cfontinue.2c0d293e.svg";